<template>
  <div>
    <div v-if="comercio">
      <div class="parallax inicio" :style="EstiloParallax">
        <div>
          <span>{{ comercio.name }}</span>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="card-text">
            <p v-if="comercio.address">
              <font-awesome-icon :icon="Icons.MAPA" />
              <span> Dirección: </span>
              <span>
                {{ comercio.address }}
              </span>
            </p>
            <p v-if="comercio.phone">
              <font-awesome-icon :icon="Icons.WHATSAPP" />
              <span> Teléfono: </span>
              <span>{{ comercio.phone }}</span>
            </p>
            <div v-if="IsAfiliado">
              <div v-if="model.afiliado.changingSubscription">
                Procesando...
              </div>
              <div v-else>
                <button
                  v-if="model.afiliado.subscribed"
                  type="button"
                  class="btn-light"
                  @click="clickCancelSubscription()"
                >
                  Dejar de recibir información
                </button>
                <button
                  v-else
                  type="button"
                  class="btn-light"
                  @click="clickSubscribe()"
                >
                  Recibir novedades
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="parallax medio" :style="EstiloParallax"></div>
      <div class="card">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="beneficios-tab"
              data-bs-toggle="tab"
              href="#beneficios"
              role="tab"
              aria-controls="beneficios"
              aria-selected="true"
              >Beneficios</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="comentarios-tab"
              data-bs-toggle="tab"
              href="#comentarios"
              role="tab"
              aria-controls="comentarios"
              aria-selected="false"
              >Comentarios</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <!-- Beneficios -->
          <div
            class="tab-pane fade show active tab-beneficios"
            id="beneficios"
            role="tabpanel"
            aria-labelledby="beneficios-tab"
          >
            <beneficio-list
              :loading="model.beneficio.loading"
              :isEmpty="model.beneficio.isEmpty"
              :list="model.beneficio.list"
              :count="model.beneficio.count"
              :maxPerPage="model.beneficio.maxPerPage"
              :currentPage="model.beneficio.currentPage"
              @on-page-changed="onBeneficioListPageChanged"
            />
          </div>

          <!-- comentarios -->
          <div
            class="tab-pane fade tab-comentarios"
            id="comentarios"
            role="tabpanel"
            aria-labelledby="comentarios-tab"
          >
            <div v-if="cargandoComentarios" class="card">
              <div class="card-body card-separador">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </div>
            </div>
            <div v-if="!cargandoComentarios">
              <!-- Si no hay comentarios -->
              <div v-if="!cantidadComentarios" class="card">
                <div class="card-body">
                  <p class="card-text sin-datos">
                    Este comercio no cuenta con comentarios actualmente
                  </p>
                </div>
              </div>

              <!-- Hay comentarios -->
              <div v-else>
                <!-- tabs Comentarios -->
                <div class="wrapper">
                  <tabsComentario>
                    <!-- Todos los Comentarios-->
                    <tabComentario title="Todos">
                      <!-- Comentario -->
                      <div
                        v-for="com in comentarios"
                        :key="com.id"
                        class="card card-comentario"
                      >
                        <div class="card-body">
                          <h5 class="card-title">
                            {{ com.titulo }}
                          </h5>
                          <div
                            class="
                              card-subtitle
                              mb-2
                              text-muted
                              alinear-izquierda
                            "
                          >
                            <star-rating
                              v-model="com.estrellas"
                              :read-only="true"
                              :show-rating="false"
                              :star-size="25"
                            ></star-rating>
                          </div>
                          <!-- Cuerpo -->
                          <p class="card-text">{{ com.cuerpo }}</p>
                          <!-- Nombre de usuario -->
                          <div class="nombre-usuario">
                            {{ com.nombreUsuario }}
                          </div>
                        </div>
                      </div>
                    </tabComentario>

                    <!-- Comentarios Buenos -->
                    <tabComentario title="Buenos">
                      <div
                        v-for="com in comentarios"
                        :key="com.id"
                        class="card card-comentario"
                      >
                        <div v-if="com.estrellas > 3">
                          <div class="card-body">
                            <h5 class="card-title">
                              {{ com.titulo }}
                            </h5>
                            <div
                              class="
                                card-subtitle
                                mb-2
                                text-muted
                                alinear-izquierda
                              "
                            >
                              <star-rating
                                v-model="com.estrellas"
                                :read-only="true"
                                :show-rating="false"
                                :star-size="25"
                              ></star-rating>
                            </div>
                            <p class="card-text">{{ com.cuerpo }}</p>
                          </div>
                        </div>
                      </div>
                    </tabComentario>

                    <!-- Comentarios Regulares -->
                    <tabComentario title="Regular">
                      <div
                        v-for="com in comentarios"
                        :key="com.id"
                        class="card card-comentario"
                      >
                        <div v-if="com.estrellas == 3">
                          <div class="card-body">
                            <h5 class="card-title">
                              {{ com.titulo }}
                            </h5>
                            <div
                              class="
                                card-subtitle
                                mb-2
                                text-muted
                                alinear-izquierda
                              "
                            >
                              <star-rating
                                v-model="com.estrellas"
                                :read-only="true"
                                :show-rating="false"
                                :star-size="25"
                              ></star-rating>
                            </div>
                            <p class="card-text">{{ com.cuerpo }}</p>
                          </div>
                        </div>
                      </div>
                    </tabComentario>

                    <!-- Comentarios Malos -->
                    <tabComentario title="Malos">
                      <div
                        v-for="com in comentarios"
                        :key="com.id"
                        class="card card-comentario"
                      >
                        <div v-if="com.estrellas < 3">
                          <div class="card-body">
                            <h5 class="card-title">
                              {{ com.titulo }}
                            </h5>
                            <div
                              class="
                                card-subtitle
                                mb-2
                                text-muted
                                alinear-izquierda
                              "
                            >
                              <star-rating
                                v-model="com.estrellas"
                                :read-only="true"
                                :show-rating="false"
                                :star-size="25"
                              ></star-rating>
                            </div>
                            <p class="card-text">{{ com.cuerpo }}</p>
                          </div>
                        </div>
                      </div>
                    </tabComentario>
                  </tabsComentario>
                </div>

                <!-- Estrellas del comercio -->
                <!-- <div id="estrellas-comercio" class="card">
                  <div class="card-body">
                    <label>Puntuación general</label>
                    <star-rating
                      v-model="comercio.estrellas"
                      :fixed-points="1"
                      :increment="0.01"
                      :read-only="true"
                      :star-size="40"
                      :text-class="'puntuacion-general'"
                    ></star-rating>
                  </div>
                </div> -->

                <!-- <div v-if="comentarios" class="card card-separador titulo">
                  <h4 class="card-title">Comentarios</h4>
                </div> -->

                <!-- <div
                  v-for="com in comentarios"
                  :key="com.id"
                  class="card card-comentario"
                >
                  <div class="card-body">
                    <h5 class="card-title">
                      {{ com.titulo }}
                    </h5>
                    <div
                      class="card-subtitle mb-2 text-muted alinear-izquierda"
                    >
                      <star-rating
                        v-model="com.estrellas"
                        :read-only="true"
                        :show-rating="false"
                        :star-size="25"
                      ></star-rating>
                    </div>
                    <p class="card-text">{{ com.cuerpo }}</p>
                  </div>
                </div> -->

                <Paginacion
                  ref="paginacionComentarios"
                  :cantidad="cantidadComentarios"
                  :cantidadPorPagina="CantidadComentariosPorPagina"
                  :paginaInicial="paginaComentarios"
                  v-on:pagina-cambiada="paginaComentariosCambiada"
                />
              </div>
            </div>
            <!-- Sección comentario de cliente -->
            <div v-if="IsAfiliado" class="tu-comentario">
              <div class="card card-separador titulo">
                <h4 class="card-title">Tu comentario</h4>
              </div>
              <div v-if="cargandoComentarioEnviado" class="card">
                <div class="card-body card-separador">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                </div>
              </div>
              <div v-show="!cargandoComentarioEnviado">
                <div class="card card-comentario" v-if="!comentarioEnviado">
                  <div class="card-body">
                    <div class="card-subtitle">
                      <label>¿Cuántas estrellas le darías?</label>
                      <star-rating
                        v-model="comentario.estrellas"
                        :show-rating="false"
                        :star-size="40"
                        :glow="5"
                      ></star-rating>
                      <h6 class="mb-2 text-muted">
                        {{ SignificadoEstrellas }}
                      </h6>
                    </div>
                    <label class="mt-3">Cuéntanos más del comercio</label>
                    <textarea
                      v-model="comentario.cuerpo"
                      class="card-text comentario-textarea"
                      rows="4"
                      maxlength="1500"
                    >
                    </textarea>
                    <p
                      v-show="
                        !comentario.cuerpo || comentario.cuerpo.length < 5
                      "
                      class="info-bajo-input"
                    >
                      Escribí al menos 5 caracteres.
                    </p>
                    <label class="mt-3"
                      >Resume tu comentario en una frase (opcional)</label
                    >
                    <input
                      v-model="comentario.titulo"
                      placeholder="Ponle un título a tu comentario"
                      class="card-title"
                    />
                  </div>
                  <div class="card-footer">
                    <button
                      @click="clickEnviarComentario()"
                      :disabled="
                        !!InfoDatosFaltantesComentario || enviandoComentario
                      "
                      type="button"
                      class="btn btn-primary"
                    >
                      <span
                        v-if="enviandoComentario"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      >
                      </span>
                      <span v-if="enviandoComentario"> Enviando...</span>
                      <span v-if="!enviandoComentario">Enviar comentario</span>
                    </button>
                    <p
                      v-if="!!InfoDatosFaltantesComentario"
                      class="info-bajo-input"
                    >
                      Falta {{ InfoDatosFaltantesComentario }}
                    </p>
                  </div>
                </div>
                <div v-if="comentarioEnviado" class="card sin-datos">
                  <div class="card-body">
                    <p class="card-text">Tu comentario ya fue enviado.</p>
                    <p class="text-muted">
                      Si no lo ves es porque está pendiente de aprobación.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="parallax fin" :style="EstiloParallax"></div>
    </div>
    <div v-if="!comercio">
      <span v-if="!cargandoBeneficios"
        >No se encontró el comercio que está buscando</span
      >
      <div v-if="cargandoBeneficios" class="spinner-border" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
    </div>
    <!--Footer-->
    <div id="formFooter">
      <div class="div-home">
        <button @click="irAHome()" type="button" class="btn btn-link link-home">
          <span>Ir Al Club</span>
          <font-awesome-icon :icon="Icons.INICIO" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// https://www.npmjs.com/package/vue-star-rating
import StarRating from "vue-star-rating";
import Swal from "sweetalert2";

import BeneficioList from "./BeneficioList.vue";
import Paginacion from "../../../components/Paginacion";
import TabComentario from "../../../components/util/TabComentario.vue";
import TabsComentario from "../../../components/util/TabsComentario.vue";

import { Api } from "../../../api";
import { BeneficioFacade as BeneficioAfiliadoFacade } from "../../../service/cliente/afiliado/beneficio/beneficio.facade";
import { BeneficioFacade as BeneficioVisitaFacade } from "../../../service/cliente/visita/beneficio/beneficio.facade";
import { ComentarioFacade } from "../../../admin/comentario/comentario.facade";
import { ComercioSubscriptionFacade } from "../../../service/cliente/afiliado/comercio-subscription/comercio-subscription.facade";
import {
  Carpetas,
  Icons as IconConstants,
  Paginacion as PaginacionConstantes,
} from "../../../constants";
import { environment } from "../../../environments/environment";
import { Util } from "../../../util";

const COMERCIO_LIMPIO = {
  nombre: "",
  direccion: "",
  estrellas: null,
  telefono: "",
  whatsapp: "",
  logo: "",
};

const COMENTARIO_LIMPIO = {
  idComercio: null,
  idUsuario: null,
  cuerpo: null,
  estrellas: null,
  titulo: null,
};

export default {
  name: "Comercio",
  components: {
    FontAwesomeIcon,
    StarRating,

    BeneficioList,
    TabComentario,
    TabsComentario,
    Paginacion,
  },
  data() {
    return {
      model: {
        afiliado: {
          id: undefined,
          subscribed: false,
          changingSubscription: false,
        },
        beneficio: {
          loading: true,
          isEmpty: false,
          list: [],
          count: undefined,
          maxPerPage: PaginacionConstantes.BENEFICIOS_POR_PAGINA,
          currentPage: 1,
        },
        comercio: {
          id: undefined,
        },
      },
      /** Cantidad de comentarios del comercio */
      cantidadComentarios: 0,
      cargandoComentarios: true,
      cargandoComentarioEnviado: true,
      // El mecanismo de copiaProfunda es usado para que los métodos "computed"
      // funcionen correctamente
      comentario: Util.copiaProfunda(COMENTARIO_LIMPIO),
      comentarioEnviado: false,
      comentarios: [],
      comercio: Util.copiaProfunda(COMERCIO_LIMPIO),
      /** Usado para mostrar feedback de que el comentario se está enviando */
      enviandoComentario: false,
      paginaComentarios: 1,
      token: null,
    };
  },
  computed: {
    BeneficioFacade() {
      if (this.IsAfiliado) {
        return BeneficioAfiliadoFacade;
      } else {
        return BeneficioVisitaFacade;
      }
    },
    CantidadComentariosPorPagina() {
      return PaginacionConstantes.COMENTARIOS_COMERCIO_UNICO_POR_PAGINA;
    },
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    EstiloParallax() {
      let bgImage = "";

      if (this.comercio && this.comercio.logoUrl) {
        bgImage = "url('" + this.CarpetaLogos + this.comercio.logoUrl + "')";
      }

      return {
        "--bg-image": bgImage,
      };
    },
    Icons() {
      return IconConstants;
    },
    /** Devuelve una cadena con los datos que faltan para que el comentario pueda ser enviado */
    InfoDatosFaltantesComentario() {
      let cadena = "";

      // Cuerpo de la computed property
      if (!this.comentario.estrellas)
        cadena = Util.agregarACadenaConComa(cadena, "estrellas");

      if (!this.comentario.cuerpo || this.comentario.cuerpo.length < 5)
        cadena = Util.agregarACadenaConComa(
          cadena,
          "cuerpo de 5 caracteres o más"
        );

      return cadena;
    },
    /**Verdadero si el usuario actual es un cliente */
    IsAfiliado() {
      return this.model.afiliado.id != null && this.token != null;
    },
    /** Devuelve string sobre el signficiado de las estrellas que puso el usuario */
    SignificadoEstrellas() {
      return this.calcularTitulo(this.comentario);
    },
  },
  created() {
    this.model.afiliado.id = localStorage.getItem("iduser");
    this.model.comercio.id = this.$route.params.id;
    this.token = localStorage.getItem("token");

    this.loadBeneficioData();
    if (this.IsAfiliado) {
      this.loadSubscriptionData();
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    calcularTitulo(comentario) {
      switch (comentario.estrellas) {
        case 1:
          return "Muy malo";
        case 2:
          return "Malo";
        case 3:
          return "Bueno";
        case 4:
          return "Muy bueno";
        case 5:
          return "Excelente";
        default:
          return "";
      }
    },
    cargarComentarios() {
      this.cargandoComentarios = true;
      if (this.paginaComentarios > 0 && this.cantidadComentarios > 0) {
        // Parámetros de paginación
        const desde =
          (this.paginaComentarios - 1) * this.CantidadComentariosPorPagina + 1;
        const hasta =
          this.paginaComentarios * this.CantidadComentariosPorPagina;

        ComentarioFacade.getListWithFilter({
          desde,
          hasta,
          idComercio: this.model.comercio.id,
        }).then((response) => {
          this.comentarios = this.rellenarTitulos(response.data);
          this.cargandoComentarios = false;
        });
      } else {
        this.comentarios = [];
        this.cargandoComentarios = false;
      }
    },
    clickEnviarComentario() {
      this.enviarComentario();
    },
    async clickSubscribe() {
      if (
        !this.model.afiliado.subscribed &&
        !this.model.afiliado.changingSubscription
      ) {
        this.model.afiliado.changingSubscription = true;

        try {
          await ComercioSubscriptionFacade.subscribe(
            this.model.afiliado.id,
            this.model.comercio.id
          );
          this.model.afiliado.subscribed = true;
        } catch (error) {
          Swal.fire("Error", "Ocurrió un error inesperado", "error");
        }

        this.model.afiliado.changingSubscription = false;
      }
    },
    async clickCancelSubscription() {
      if (
        this.model.afiliado.subscribed &&
        !this.model.afiliado.changingSubscription
      ) {
        this.model.afiliado.changingSubscription = true;

        try {
          await ComercioSubscriptionFacade.cancelSubscription(
            this.model.afiliado.id,
            this.model.comercio.id
          );
          this.model.afiliado.subscribed = false;
        } catch (error) {
          Swal.fire("Error", "Ocurrió un error inesperado", "error");
        }

        this.model.afiliado.changingSubscription = false;
      }
    },
    enviarComentario() {
      this.enviandoComentario = true;

      // Rellenar campos
      this.comentario.idComercio = this.comercio.id;
      this.comentario.idUsuario = this.model.afiliado.id;

      Api.Comentario.enviar(this.comentario)
        .then(() => {
          this.comentarioEnviado = true;
        })
        .finally(() => {
          this.enviandoComentario = false;
        });
    },
    getBeneficioList(startIndex) {
      return this.BeneficioFacade.getListByComercioWithPagination(
        this.model.comercio.id,
        {
          startIndex,
          maxCount: this.model.beneficio.maxPerPage,
        }
      );
    },
    irAHome() {
      this.$router.push("/home");
    },
    // Usado para la primera vez y para cuando se cambia el id de comercio
    // en la url sin recargar el componente
    async load() {
      this.paginaBeneficios = 1;
      this.paginaComercios = 1;

      this.cargandoComentarios = true;
      this.cargandoComentarioEnviado = true;

      this.comercio = (await Api.Comercio.get(this.model.comercio.id)).data;

      this.cantidadComentarios = 1;

      // Obtener comentarios para este comercio
      this.cantidadComentarios = (
        await ComentarioFacade.countWithFilter({
          idComercio: this.model.comercio.id,
        })
      ).data;

      if (this.cantidadComentarios > 0) {
        this.cargarComentarios();
      } else {
        this.cargandoComentarios = false;
        this.comentarios = [];
      }

      const comentario = (
        await Api.Comentario.getEnviado(
          this.model.comercio.id,
          this.model.afiliado.id
        )
      ).data;

      this.comentarioEnviado = comentario != null;

      // Solo cambiar en el then para que no pueda enviar comentario si falla
      this.cargandoComentarioEnviado = false;
    },
    async loadBeneficioData() {
      const model = this.model.beneficio;

      model.loading = true;

      model.count = await this.BeneficioFacade.countByComercioId(
        this.model.comercio.id
      );

      if (model.count > 0) {
        model.isEmpty = false;

        model.list = await this.getBeneficioList();
      } else {
        model.isEmpty = true;
      }

      model.loading = false;
    },
    async loadSubscriptionData() {
      const comercioId = this.$route.params.id;

      this.model.afiliado.subscribed =
        await ComercioSubscriptionFacade.isAfiliadoSubscribedToComercio(
          this.model.afiliado.id,
          comercioId
        );
    },
    async onBeneficioListPageChanged(pageNumber) {
      const model = this.model.beneficio;

      model.loading = true;

      model.currentPage = pageNumber;

      const startIndex = pageNumber * model.maxPerPage;

      model.list = await this.getBeneficioList(startIndex);

      model.loading = false;
    },
    paginaBeneficiosCambiada(numero) {
      this.paginaBeneficios = numero;
      this.loadBeneficioList();
    },
    paginaComentariosCambiada(numero) {
      this.paginaComentarios = numero;
      this.cargarComentarios();
    },
    /** Rellena los títulos vacíos */
    rellenarTitulos(comentarios) {
      for (let i = 0; i < comentarios.length; i++) {
        const c = comentarios[i];
        if (!c.titulo) c.titulo = this.calcularTitulo(c);
      }

      return comentarios;
    },
  },
};
</script>
<style scoped>
.card-title {
  margin-left: 5px;
  margin-right: 5px;
}
.parallax {
  background-color: var(--color-moda-h);

  background-image: var(--bg-image);
  /* Set a specific height */
  height: 400px;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;
}
.parallax > * {
  text-align: center;
  color: rgb(191, 191, 191);
}
.parallax > * span {
  background-color: rgb(18, 18, 18);
  color: rgb(255, 255, 255);
  padding: 18px;
  font-size: 25px;
  letter-spacing: 10px;
  line-height: 75px;
}
.parallax.medio {
  height: 100px;
}
.parallax.fin {
  height: 100px;
}
.card {
  text-align: justify;
}
.sin-datos {
  margin: auto;
  text-align: center;
}
th {
  vertical-align: middle !important;
}

.card-comentario {
  width: 100%;
}

.card-comentario input {
  width: 100%;
}

.card-comentario .card-body .card-subtitle:not(.alinear-izquierda) {
  text-align: center;
  justify-content: center;
  justify-items: center;
}

.card-comentario .card-body .card-subtitle:not(.alinear-izquierda) div {
  justify-content: center;
}

.card-comentario .nombre-usuario {
  font-style: italic;
  font-size: 0.85rem;
}

.comentario-textarea {
  width: 100%;
  height: 150px;
  resize: none;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}
.div-home {
  align-self: flex-start;
}

.div-home button {
  color: var(--color-estructura-a);
}

.div-home svg {
  margin-left: 10px;
}

.link-home {
  cursor: pointer;
}

.titulo {
  text-align: center;
}
</style>
<style>
.puntuacion-general {
  font-size: 20px;
}
</style>
